import styled from "styled-components";
import { getColorByPercentage } from "@/lib/Helpers/ratings";

const RatingBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) =>
    theme.kallisto.color.background.static.backgroundDisabled};
  border-radius: 2px;
  overflow: hidden;
`;

const RatingBarFill = styled.div<{ $percentage: number }>`
  height: 100%;
  width: ${({ $percentage }) => $percentage}%;
  background-color: ${({ $percentage, theme }) =>
    getColorByPercentage($percentage, theme)};
  border-radius: 2px;
  transition: width 0.3s ease;
`;

interface RatingBarProps {
  percentage: number;
}

const RatingBar: React.FC<RatingBarProps> = ({ percentage }) => {
  return (
    <RatingBarContainer>
      <RatingBarFill $percentage={percentage} />
    </RatingBarContainer>
  );
};

export default RatingBar;
